<template>
  <div>
    <el-row :gutter="16" :span="24" class="card-content" justify="space-between">
      <el-col :key="index" :lg="6" :md="12" :xl="6" class="card-item" v-for="(item, index) in cardOptions">
        <dataCard :active="0" :option="item" v-loading="loading.cardLoading"></dataCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <reportCard
          :config="distribution.chart"
          :style="`height: ${reportHeight};`"
          v-loading="loading.distributeLoading"
        >
          <div slot="reportInfo" class="report-info">
            <div class="info-title">{{ $t('ocean-bi::sc-analysis::card-day') }}</div>
            <ul>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::five-day-distRate') }}</span>
                </div>
                <div>{{ $dataCheck(distribution.data.distRate) }}%</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::day-30-subOrder') }}</span>
                </div>
                <div>{{ $dataCheck(distribution.data.day30OrderNum) }}</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::day-5-dispatcherNum') }}</span>
                </div>
                <div>{{ $dataCheck(distribution.data.day5DispatcherNum) }}</div>
              </li>
            </ul>
          </div>
        </reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <reportCard
          :config="internetConfig.chart"
          :style="`height: ${reportHeight};`"
          v-loading="loading.internetLoading"
        >
          <div slot="reportInfo" class="report-info">
            <div class="info-title">{{ $t('ocean-bi::sc-analysis::card-day') }}</div>
            <ul>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::上网率') }}</span>
                </div>
                <div>{{ $dataCheck(internetConfig.data.internetRate) }}%</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::月子订单数') }}</span>
                </div>
                <div>{{ $dataCheck(internetConfig.data.monthOrderNum) }}</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::monthNetworkNum') }}</span>
                </div>
                <div>{{ $dataCheck(internetConfig.data.monthNetworkNum) }}</div>
              </li>
            </ul>
          </div>
        </reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <reportCard
          :config="receiveConfig.chart"
          :style="`height: ${reportHeight};`"
          v-loading="loading.receiveLoading"
        >
          <div slot="reportInfo" class="report-info">
            <div class="info-title">{{ $t('ocean-bi::sc-analysis::card-day') }}</div>
            <ul>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::receiveRate') }}</span>
                </div>
                <div>{{ $dataCheck(receiveConfig.data.receiveRate) }}%</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::day30OrderNum30diff') }}</span>
                </div>
                <div>{{ $dataCheck(receiveConfig.data.day30OrderNum30diff) }}</div>
              </li>
              <li class="info-item">
                <div class="info-desc">
                  <span class="ring"></span>
                  <span>{{ $t('ocean-bi::sc-analysis::day30Received30diff') }}</span>
                </div>
                <div>{{ $dataCheck(receiveConfig.data.day30Received30diff) }}</div>
              </li>
            </ul>
          </div>
        </reportCard>
      </el-col>
    </el-row>
    <EditReturnRate v-model="visible" :rate="returnRate" @save="updateCard"></EditReturnRate>
  </div>
</template>

<script>
import moment from 'moment'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import EditReturnRate from './components/editReturnRate.vue'
import setConfig from './setConfig'
import {
  getSupplierOverview,
  getDistributeChart,
  getDistributeOverview,
  getInternetChart,
  getInternetOverview,
  getReceiveChart,
  getReceiveOverview,
} from '@/server/etl'
export default {
  name: 'scAnalysis',
  mixins: [setConfig],
  components: { dataCard, reportCard, EditReturnRate },
  data() {
    return {
      reportHeight: '350px',
      cardOptions: {},
      distribution: {
        data: {},
        chart: {},
      },
      internetConfig: {
        data: {},
        chart: {},
      },
      receiveConfig: {
        data: {},
        chart: {},
      },
      visible: false,
      params: {
        orgUnitId: this.$store.state.user.merchantId,
        dt: moment().format('YYYY-MM-DD'),
      },
      returnRate: 0.05, // 退货率
      loading: {
        cardLoading: false,
        distributeLoading: false,
        internetLoading: false,
        receiveLoading: false,
      },
      timer: null,
    }
  },
  created() {
    this.cardOptions = this.getCardConfig({})
    this.init()
    this.timer = setInterval(() => {
      this.init()
    }, 600000)
  },
  methods: {
    editCard() {
      this.visible = true
    },
    init() {
      this.getCardInfo()
      this.getDistributeInfo()
      this.getInternetInfo()
      this.getReceiveInfo()
    },
    updateCard(rate) {
      this.returnRate = rate
      this.getCardInfo()
    },
    async getCardInfo() {
      this.loading.cardLoading = true
      const { data } = await getSupplierOverview({ ...this.params, returnRate: this.returnRate })
      this.loading.cardLoading = false
      if (data.code === this.$code) {
        if (data.data.datas && data.data.datas.length) {
          this.cardOptions = this.getCardConfig(data.data.datas[0])
        }
      }
    },
    async getDistributeInfo() {
      this.loading.distributeLoading = true
      const [chart, data] = await Promise.all([getDistributeChart(this.params), getDistributeOverview(this.params)])
      this.loading.distributeLoading = false
      if (chart.data.code === this.$code) {
        this.distribution.chart = this.getDistributionConfig((chart.data.data && chart.data.data.datas) || [])
      }
      if (data.data.code === this.$code) {
        if (data.data.data.datas && data.data.data.datas.length) {
          this.distribution.data = data.data.data.datas[0]
        }
      }
    },
    async getInternetInfo() {
      this.loading.internetLoading = true
      const [chart, data] = await Promise.all([getInternetChart(this.params), getInternetOverview(this.params)])
      this.loading.internetLoading = false
      if (chart.data.code === this.$code) {
        this.internetConfig.chart = this.getInternetConfig((chart.data.data && chart.data.data.datas) || [])
      }
      if (data.data.code === this.$code) {
        if (data.data.data.datas && data.data.data.datas.length) {
          this.internetConfig.data = data.data.data.datas[0]
        }
      }
    },
    async getReceiveInfo() {
      this.loading.receiveLoading = true
      const [chart, data] = await Promise.all([getReceiveChart(this.params), getReceiveOverview(this.params)])
      this.loading.receiveLoading = false
      if (chart.data.code === this.$code) {
        this.receiveConfig.chart = this.getReceiveConfig((chart.data.data && chart.data.data.datas) || [])
      }
      if (data.data.code === this.$code) {
        if (data.data.data.datas && data.data.data.datas.length) {
          this.receiveConfig.data = data.data.data.datas[0]
        }
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
.report-info {
  width: 330px;
  padding: 16px 24px;
  background: #fafbfc;
  border-radius: 8px;
  box-sizing: border-box;
  .info-title {
    font-size: 14px;
    color: #8a909d;
    margin-bottom: 12px;
  }
  .info-item {
    padding: 20px 0;
    border-bottom: 1px solid #ebeaea;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #010517;
    &:last-child {
      border-bottom: 0;
    }
    .info-desc {
      display: flex;
      align-items: center;
      font-size: 14px;
      .ring {
        width: 10px;
        height: 10px;
        border: 2px solid #ffcc5e;
        border-radius: 50%;
        margin-right: 12px;
      }
    }
  }
}
</style>
